<h3 [class]="'margin-0 sparro-grey-800 font-regular overflow-hidden ' +
  (cardWidth<=541 ? 'blog-subtitle-md': 'blog-subtitle')">
  <ng-container *ngIf="blog.tagline">
    {{ blog.tagline }}
  </ng-container>
  <ng-container *ngIf="!blog.tagline">No description</ng-container>
</h3>
